import { newToolFilterOAuthMcp } from "../oauth.ts";

export const todoistMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.todoist.com/static/apple-touch-icon.png",
  url: "https://ai.todoist.net/mcp",
  label: "Todoist",
});
